module.exports = __webpack_public_path__ + "/static/sito/landing/agenti-zero-emissioni/media/cover.1577d547.jpg";